import type { CsvIntegrationConfig } from '../../entities/platform-entities/integration/csv-integration-config.interface';
import type { SfccIntegrationConfig } from '../../entities/platform-entities/integration/sfcc-integration-config.interface';

export class ProductFlags {
  liveSessions: boolean = true;
  polls: boolean = false;
  sceneBuilder: boolean = false;
  carousels: boolean = true;
}

const defaultProductFlags = {
  liveSessions: true,
  polls: false,
  sceneBuilder: false,
  carousels: true,
};

export const SHOPIFY_INTEGRATION_CLASSES = ['ShopifyCustom', 'MaxbpCustom'] as const;

export function isShopifyIntegrationClass(integrationClass: string | undefined): boolean {
  return (
    !!integrationClass &&
    (SHOPIFY_INTEGRATION_CLASSES as readonly string[]).includes(integrationClass)
  );
}

export class DbIntegrationCredentials {
  username: string = '';
  password: string = '';
  accountName: string = '';
  environment: string = '';
}

export class DbAppSessionsStorageModel {
  accessToken: string;
  id: string;
  isOnline: boolean;
  scope: string;
  shop: string;
  state: string;
  storeId?: string;
  domains?: string[];
}

export class DbIntegrationModel {
  id: string;
  integrationClass: string = 'BaseGeneric';
  apiUrl: string = '';
  websiteUrl: string = '';
  apiToken: string = '';
  storeId: string;
  cartPath: string = 'checkout';
  productUniqueIdFieldName: string = 'id';
  productVariantUniqueIdFieldName: string = 'sku';
  productCatalogUrl: string = '';
  productIds: string[] = [];
  enableAllProducts: boolean = false;
  credentials: DbIntegrationCredentials = {
    username: '',
    password: '',
    accountName: '',
    environment: '',
  };
  EmbeddingFontFamily: string;
  extraProductIds?: string;
  productFlags: ProductFlags = defaultProductFlags;
  headerElements: string = '';
  customerStoreId: string = '';
  csvIntegrationConfig?: CsvIntegrationConfig;
  cronScheduledSync?: string;
  cronScheduledSyncTimezone?: string;
  sfccIntegrationConfig?: SfccIntegrationConfig;

  static fromDb(data: Partial<DbIntegrationModel>): DbIntegrationModel {
    if (!data) return data;
    const instance = new DbIntegrationModel();

    Object.assign(instance, data);

    if (!data.productFlags) {
      instance.productFlags = defaultProductFlags;
    } else {
      instance.productFlags = Object.assign(new ProductFlags(), data.productFlags);
    }

    return instance;
  }
}
